import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

class CustomerGroupProjectPill extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {

        };
    }

    handleRemove = () => {
        this.props.handleRemove(this.props.customerGroupProject);
    }

    render = () => {
        return (
            <tr>
                <td>
                    <span className={this.props.newlyAssigned ? "user-no-longer-assigned" : "text-center"}> {this.props.customerGroupProject.customerGroup.name}</span>
                </td>

                <td className="text-center">
                    <span  className={this.props.newlyAssigned ? "user-no-longer-assigned" : "text-center"} style={{"fontSize" : "14px !important"}}>
                        {this.props.customerGroupProject.year}
                    </span>
                </td>

                <td>
                    <button type="button" onClick={this.handleRemove} style={{"background" : "transparent" , "border" : "none"}}>
                        <a className="icon-btn">
                            <span>
                                <span className="md-remove"></span>
                            </span>
                        </a>
                    </button>
                </td>
            </tr>
        );
    }

}

CustomerGroupProjectPill.propTypes = {
  customerGroupProject: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapDispatchToProps
)(CustomerGroupProjectPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/CustomerGroupProjectPill.js
 **/